const defaultCrudConfig = {
    endpoint: 'concepts',
    primaryKey: 'codeId',
    functions: {
        fetchAll: {
            method: 'get',
            returnType: 'Array',
            service: 'cds',
            args: [],
            query: {
                property: 'queryClass=FindAll'
            }
        },
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            args: ['codeId'],
            query: {
                filter: 'nodeId=#@nodeId@#',
                property: 'queryClass=PrimaryKey'
            }
        },
        update: {
            method: 'put',
            returnType: 'Object',
            service: 'cds',
            args: ['codeId', 'nodeDoc']
        },
        delete: {
            method: 'delete',
            returnType: 'String',
            service: 'cds',
            args: ['codeId']
        },
        insert: {
            method: 'post',
            returnType: 'Object',
            service: 'cds',
            args: ['codeDoc']
        }
    }
};

export default defaultCrudConfig;
